/* eslint-disable perfectionist/sort-objects -- route keys must be ordered by specificity (most-specific first) to match correctly */
export const featurePageMapping: { [key: string]: PageMapping } = {
	"/settings/integrations": {
		actions: [],
		buttons: [],
		description: "Manage external integrations.",
		descriptionKey: "nav.integrations.module.description",
		icon: "hub",
		label: "Integrations",
		labelKey: "nav.integrations.module.label",
		nav: false,
		title: ""
	},
	"/settings/integrations/add": {
		actions: [],
		buttons: [],
		description: "",
		label: "Add Integration",
		labelKey: "nav.integrations.add.label",
		nav: false,
		title: ""
	},
	"/settings/integrations/.+": {
		actions: [],
		buttons: [],
		description: "",
		identifier: true,
		label: "Integration",
		labelKey: "nav.integrations.detail.label",
		nav: false,
		title: ""
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping
};
